import ImgixClient from "@imgix/js-core";

export default ImgixClient.targetWidths();
